import $ from 'jquery';

const SibOverlay = {
    bindEvents: () => {
        const sibOverlays = document.getElementsByClassName('sib-overlay__toggle');
        if (sibOverlays.length) {
            SibOverlay.init(sibOverlays);
        }

    },

    init: (overlays) => {
        for (let i = 0; i < overlays.length; i++) {
            overlays[i].addEventListener('click', (e) => {
                e.preventDefault();
                let overlayContentType = overlays[i].hasAttribute('data-type') ? overlays[i].getAttribute('data-type') : '';
                // track current scroll position when loading overlay
                if (!document.getElementsByClassName('sib-overlay active')[0]) {
                    document.getElementsByTagName('body')[0].setAttribute('data-y', window.pageYOffset);
                }

                if (overlays[i].hasAttribute('data-target')) {
                    let overlayModal = document.getElementById(overlays[i].getAttribute('data-target'));
                    if (overlayModal) {
                        // hook before displaying the overlay
                        if (overlayContentType == 'contact-sales') {
                            SibOverlay.loadContactTeam(e);
                        }
                        overlayModal.classList.toggle('active');
                        SibOverlay.updateOverlayStatus();
                    }
                } else {
                    // open/close default overlay and populate with video, image or custom component.
                    let overlay = document.getElementsByClassName('sib-overlay sib-overlay--default')[0];
                    let wrapper = document.getElementById('sib-overlay__content--default');

                    if (overlay.classList.contains('active')) {
                        wrapper.innerHTML = '';
                        overlay.classList.remove('active');
                        SibOverlay.updateOverlayStatus();
                    } else {
                        let elm = overlays[i];
                        switch (overlayContentType) {
                            case 'video':
                                let id = elm.hasAttribute('data-ref') ? elm.getAttribute('data-ref') : '';
                                let videoType = elm.hasAttribute('data-video') ? elm.getAttribute('data-video') : '';
                                SibOverlay.loadVideo(id, videoType, wrapper, elm);
                                break;

                            case 'image':
                                let url = elm.hasAttribute('data-ref') ? elm.getAttribute('data-ref') : '';
                                SibOverlay.loadImage(url, wrapper);
                                break;

                            case 'mediaimage':
                                let mediaurl = elm.hasAttribute('data-ref') ? elm.getAttribute('data-ref') : '';
                                let title = elm.hasAttribute('data-title') ? elm.getAttribute('data-title') : '';
                                let description = elm.hasAttribute('data-description') ? elm.getAttribute('data-description') : '';
                                let size = elm.hasAttribute('data-size') ? elm.getAttribute('data-size') : '';
                                let filetype = elm.hasAttribute('data-filetype') ? elm.getAttribute('data-filetype') : '';
                                // console.log(mediaurl);
                                // console.log(title);

                                SibOverlay.loadMediaImage(mediaurl, wrapper, title, description, size, filetype);
                                break;

                            case 'vacancies':
                                let vacancyWrapper = document.getElementById('vacancies__wrapper');
                                vacancyWrapper.classList.add('active');
                                break;

                        }
                        overlay.classList.add('active');
                        SibOverlay.updateOverlayStatus();
                    }
                }
                if (overlays[i].hasAttribute('data-focus')) {
                    console.log(overlays[i].getAttribute('data-focus'));
                    let focusElement = document.getElementById(overlays[i].getAttribute('data-focus'));
                    if (focusElement) {
                        focusElement.focus();
                    }
                }
            });
        }

        // close modal on overlay click
        $('.sib-overlay__content').on('click', function(e) {
            if (e.target !== this)
                return;

            let activeOverlay = document.getElementsByClassName('sib-overlay active')[0];
            if (activeOverlay) {
                let close = activeOverlay.getElementsByClassName('sib-overlay__toggle')[0];
                if (close) {
                    close.click();
                }
            }
        });

        // close overlay on Esc
        let body = document.getElementsByTagName('body')[0];
        document.onkeydown = function(e) {
            e = e || window.event;
            let isEscape = false;
            if ('key' in e) {
                isEscape = (e.key == "Escape" || e.key == "Esc");
            } else {
                isEscape = (e.keyCode == 27);
            }

            // close overlay on Esc
            if (body.classList.contains('overlay-active') && isEscape) {
                let activeOverlay = document.getElementsByClassName('sib-overlay active')[0];
                if (activeOverlay) {
                    let close = activeOverlay.getElementsByClassName('sib-overlay__toggle')[0];

                    if (close) {
                        close.click();
                        // close careers
                        let vacancyWrapper = document.getElementById('vacancies__wrapper');
                        vacancyWrapper.classList.remove('active');
                    }
                }
            }
        };

        // auto-open toggles
        setTimeout(function () {
            let autoLoadElement = document.getElementsByClassName('sib-overlay__toggle auto-load');
            if (autoLoadElement.length) {
                autoLoadElement[0].click();
            }
        }, 1000);
    },

    /**
     * this method will toggle classes to let body and html
     * keep track of overlay states.
     * this will also keep track of previous scroll-position
     */
    updateOverlayStatus: () => {
        let overlay = document.getElementsByClassName('sib-overlay active');
        let body = document.getElementsByTagName('body')[0];
        let datepickersContainer = document.getElementsByClassName('datepickers-container')[0];

        if (overlay.length) {
            document.getElementsByTagName('html')[0].classList.add('overlay-active');
            document.getElementsByTagName('body')[0].classList.add('overlay-active');
            if (body.hasAttribute('data-y')) {
                let scrollY = parseInt(body.getAttribute('data-y'));
                body.style.top = `-${scrollY}px`;
                datepickersContainer.style.top = `${scrollY}px`;
            }
        } else {
            document.getElementsByTagName('html')[0].classList.remove('overlay-active');
            let body = document.getElementsByTagName('body')[0];
            if (body) {
                body.classList.remove('overlay-active');
                body.style.top = "0";
                datepickersContainer.style.top = "0";
                if (body.hasAttribute('data-y')) {
                    let scrollY = parseInt(body.getAttribute('data-y'));
                    window.scrollTo(0, scrollY);
                }
            }
        }
        if (datepickersContainer && overlay[0]) {
            overlay[0].addEventListener('scroll', function (e) {
                let datepickers = document.getElementsByClassName('datepicker');
                for (let i = 0; i < datepickers.length; i++) {
                    if (datepickers[i].classList.contains('active')) {
                        datepickers[i].classList.remove('active');
                    }
                }
            });
        }

    },

    /**
     * This will load youtube video on the default overlay.
     */
    loadVideo: (VideoId, videoType, wrapper, elm) => {
        // console.log(videoType)
        let videoUrl;
        if (videoType == 'youtube') {
            videoUrl = `https://www.youtube.com/embed/${VideoId}`;
        } else {
            videoUrl = `https://player.vimeo.com/video/${VideoId}`;
        }

        wrapper.innerHTML = `<div class="sib-video__embed">
                <iframe width="100%" height="auto" src="${videoUrl}?autoplay=1" frameborder="0"
allow="autoplay; encrypted-media" allowfullscreen></iframe>
            </div>`;
    },

    /**
     * This will load image on the default overlay
     */
    loadImage: (imageUrl, wrapper) => {
        wrapper.innerHTML = `<div class="sib-image__large">
            <img src="${imageUrl}" />
        </div>`;
    },

    /**
     * this will load contact-sales-team info to the overlay
     */
    loadContactTeam: (e) => {
        let $elm = $(e.currentTarget);
        let $wrapper = $('#sib-overlay--contact-team');

        // check if member requires form
        let enableForm = $elm.attr('data-form');
        if (typeof enableForm !== typeof undefined && enableForm !== 'false') {
            $wrapper.find('.sib-overlay-team--form').removeClass('hidden');
        } else {
            $wrapper.find('.sib-overlay-team--form').addClass('hidden');
        }

        $wrapper.find('.sib-overlay-team__name').html($elm.find('.staff-details__name').html()); // update name
        $wrapper.find('.sib-overlay-team__image').css('background-image', `url('${$elm.find('.staff-details__image').text()}')`); // update image
        $wrapper.find('.sib-overlay-team__description').html($elm.find('.staff-details__member-text').html()); // staff text
        $wrapper.find('.sib-overlay-team__connect-phone').html('<a href="tel:' + $elm.find('.staff-details__phone').html() + '">' + $elm.find('.staff-details__phone').html() + '</a>');  // phone number
        $wrapper.find('.sib-overlay-team__connect-email').html('<a href="mailto:' + $elm.find('.staff-details__email').html() + '">' + $elm.find('.staff-details__email').html() + '</a>' );  // email address
        $wrapper.find('[name="fields[salesEmailTo]"]').val($elm.find('.staff-details__email').html());  // email address
        $wrapper.find('.sib-overlay-team--form-name').html($elm.find('.staff-details__firstname').html());  // first name
        // linkedin
        let $linkedin = $elm.find('.staff-details__linked-in').text();
        if ($linkedin !== '') {
            $wrapper.find('.sib-overlay-team__linkedin').attr('href', $linkedin).removeClass('hidden');
        } else {
            $wrapper.find('.sib-overlay-team__linkedin').addClass('hidden');
        }
    },

    /**
     * This will load a media image on the default overlay
     */
    loadMediaImage: (imageUrl, wrapper, title, description, size, type) => {

        wrapper.innerHTML = `<div class="sib-image__large">
            <img src="${imageUrl}" width="100%"/>
            <div class="sib-image__details">
                <div class="sib-image__details--left">
                    <div class="sib-image__title"><span class="sib-image__title--heading">${title}</span><div class="sib-image__title--details"><span>${size}mb</span><span>${type}</span></div></div>
                    <div class="sib-image__description">${description}</div>
                </div>
                <div class="sib-image__details--right">
                    <div class="sib-image__terms">
                    <div class="sib-form-group form-group-newsletter-signup">
                        <input type="checkbox"  value="1" id="termsAndConditions">
                        <label for="termsAndConditions" class="sib-checkbox">
                            I agree to the <a href="/terms-conditions">terms and conditions</a>
                        </label>
                    </div></div>
                    <a data-href="${imageUrl}" download="${title}" id="download" class="button button-primary button-download button-disabled" >Download</a>
                </div>
            </div>
        </div>`;
        SibOverlay.agreementCheckbox();
    },
    agreementCheckbox: () => {
        const checkbox = document.getElementById('termsAndConditions');
        const download = document.getElementById('download');
        if (checkbox) {
            checkbox.addEventListener('change', function () {

                if (this.checked) {
                    download.classList.remove('button-disabled');
                    download.setAttribute('href', download.getAttribute('data-href'));
                } else {
                    download.classList.add('button-disabled');
                    download.removeAttribute('href');
                }
            });
        }

    },
    download: () => {


    }
};

module.exports = SibOverlay;



// WEBPACK FOOTER //
// ./src/js/partials/overlay.js